<script setup lang="ts">
import type { Placement } from '../../lib/types.ts'
import Button from '../Button/Button.vue'
import { toasts } from './toast'
import './toast.scss'

interface Props {
  placement?: Placement
}

const {
  placement = 'bottom-end',
} = defineProps<Props>()
</script>

<template>
  <Teleport to="body">
    <div class="vui-toast-wrapper" :class="placement">
      <TransitionGroup name="toast" tag="ul" class="vui-toast-list">
        <template v-for="[toastId, toast] in toasts" :key="toastId">
          <Component
            :is="toast.body"
            v-if="toast.body"
            v-bind="{ data: toast.bodyProps, toastId }"
          />
          <li v-else class="vui-toast-item">
            <div class="vui-toast-item-content">
              <strong>{{ toast.title }}</strong>
              <p v-if="toast.description">
                {{ toast.description }}
              </p>
            </div>
            <Button v-if="toast.action" size="s" @click="toast.action.handler(toast.id)">
              {{ toast.action.label }}
            </Button>
          </li>
        </template>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<style scoped>
.toast-move,
.toast-enter-active,
.toast-leave-active {
  transition: var(--transition);
}

.toast-enter-from {
  opacity: 0;
  transform: translateY(24px) scale(0.95);
}

.toast-leave-to {
  opacity: 0;
  transform: translateY(-24px) scale(0.95);
}

.toast-leave-active {
  position: absolute;
}
</style>
